import { Directive, Input } from '@angular/core';

export interface SortingCriteria {
    column: string;
    descending: boolean;
}

@Directive({
    selector: 'ads-sorting',
})
export class SortingDirective {
    public sortingCriteria: SortingCriteria;
    public config: string;
    @Input() public pagedItems: Record<string, unknown>[] = [];

    constructor() {
        this.init();
    }

    public init(): void {
        this.sortingCriteria = {
            column: 'locationName', // default sorting column.
            descending: true,
        };

        this.config = this.sortingCriteria.descending ? '-' + this.sortingCriteria.column : this.sortingCriteria.column;
        this.sorting();
    }

    public _orderByComparator(a: unknown, b: unknown): number {
        let aVal: string | number = 0;
        let bVal: string | number = 0;

        if (a === null || a === undefined) {
            aVal = 0;
        } else if (typeof a === 'string') {
            aVal = a;
        } else if (typeof a === 'number') {
            aVal = a;
        } else {
            aVal = String(a);
        }

        if (b === null || b === undefined) {
            bVal = 0;
        } else if (typeof b === 'string') {
            bVal = b;
        } else if (typeof b === 'number') {
            bVal = b;
        } else {
            bVal = String(b);
        }

        if (typeof aVal === 'string' && typeof bVal === 'string') {
            // String comparison
            if (aVal.toLowerCase() < bVal.toLowerCase()) {
                return -1;
            }
            if (aVal.toLowerCase() > bVal.toLowerCase()) {
                return 1;
            }
        } else {
            // Numeric comparison
            const aNum = typeof aVal === 'number' ? aVal : parseFloat(aVal);
            const bNum = typeof bVal === 'number' ? bVal : parseFloat(bVal);
            if (!isNaN(aNum) && !isNaN(bNum)) {
                if (aNum < bNum) {
                    return -1;
                }
                if (aNum > bNum) {
                    return 1;
                }
            }
        }

        return 0; // equal each other
    }

    public changeSorting(columnName: string): void {
        const sort = this.sortingCriteria;
        if (sort.column === columnName) {
            sort.descending = !sort.descending;
        } else {
            sort.column = columnName;
            sort.descending = false;
        }
        this.config = this.sortingCriteria.descending ? '-' + this.sortingCriteria.column : this.sortingCriteria.column;
        this.sorting();
    }

    public sorting(): void {
        if (this.pagedItems !== undefined) {
            // make a copy of the input's reference
            this.pagedItems = [...this.pagedItems];
            let value = this.pagedItems;

            if (!Array.isArray(value)) {
                return;
            }

            if (!Array.isArray(this.config) || (Array.isArray(this.config) && this.config.length === 1)) {
                const propertyToCheck: string = !Array.isArray(this.config) ? this.config : this.config[0];
                const desc = propertyToCheck.substr(0, 1) === '-';

                // Basic array
                if (!propertyToCheck || propertyToCheck === '-' || propertyToCheck === '+') {
                    value = !desc ? value.sort() : value.sort().reverse();
                } else {
                    const property: string =
                        propertyToCheck.substr(0, 1) === '+' || propertyToCheck.substr(0, 1) === '-'
                            ? propertyToCheck.substr(1)
                            : propertyToCheck;

                    value = value.sort((a: Record<string, unknown>, b: Record<string, unknown>) => {
                        return !desc
                            ? this._orderByComparator(a[property], b[property])
                            : -this._orderByComparator(a[property], b[property]);
                    });
                }
                this.pagedItems = value;
            } else {
                // Loop over property of the array in order and sort
                value = value.sort((a: Record<string, unknown>, b: Record<string, unknown>) => {
                    for (let i = 0; i < this.config.length; i++) {
                        const desc = this.config[i].substr(0, 1) === '-';
                        const property =
                            this.config[i].substr(0, 1) === '+' || this.config[i].substr(0, 1) === '-'
                                ? this.config[i].substr(1)
                                : this.config[i];

                        const comparison = !desc
                            ? this._orderByComparator(a[property], b[property])
                            : -this._orderByComparator(a[property], b[property]);

                        // Don't return 0 yet in case of needing to sort by next property
                        if (comparison !== 0) {
                            return comparison;
                        }
                    }
                    return 0; // equal each other
                });
                this.pagedItems = value;
            }
        }
    }
}
